module.exports = __webpack_public_path__ + "img/clothes.09a1a691.jpg";